module.exports = __webpack_public_path__ + "media/images/sp/accessories/dress/dress_02_thumb-6a42dfa7a67995944a2f887ac7d91b49.jpg";